import React from "react";
import styled from "styled-components";

const Applications = ({ applications }) => {
  return (
    <StyledTable>
      <thead>
        <tr>
          <TableHeader>Marka</TableHeader>
          <TableHeader>Model</TableHeader>
          <TableHeader>Rok</TableHeader>
          <TableHeader>Parametry</TableHeader>
        </tr>
      </thead>
      <tbody>
        {applications.map((item, k) => (
          <TableRow key={k}>
            <TableBody>{item.make}</TableBody>
            <TableBody>{item.model}</TableBody>
            <TableBody>{item.year}</TableBody>
            <TableBody>{item.parameter}</TableBody>
          </TableRow>
        ))}
      </tbody>
    </StyledTable>
  );
};

export default Applications;

const StyledTable = styled.table`
  width: 100%;
  margin-botton: 16px;
`;

const TableRow = styled.tr`
  tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;

const TableHeader = styled.th`
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border-top: 1px solid #dee2e6;
  padding: 14px;
`;

const TableBody = styled.td`
  border-top: 1px solid #dee2e6;
  font-size: 13px;
  padding: 14px;
`;
